
export default {
    data: () => ({
        partnerCodes: {
            hr_co: 'hr_co',
            eco_bw: 'eco_bw',
        }
    })
}
